var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:add"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 542",
    cx: 8.33301,
    cy: 8.33301,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 1C4.35775 1 1 4.35775 1 8.5C1 12.6422 4.35775 16 8.5 16C12.6422 16 16 12.6422 16 8.5C16 4.35775 12.6422 1 8.5 1ZM12.25 9.25H9.25V12.25H7.75V9.25H4.75V7.75H7.75V4.75H9.25V7.75H12.25V9.25Z",
    fill: "#6CBAA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBackground);
export default __webpack_public_path__ + "static/media/plus-background.ae7d4e834783870d1a17232552aca1a3.svg";
export { ForwardRef as ReactComponent };